<template>
	<div>
		<table class="users-list-table table table-primary table-striped">
			<thead>
				<tr>
					<th width="5%">
						<label class="input-checkbox-container">
							<input
								type="checkbox"
								class="input-checkbox"
								v-model="selectAll"
							/>
							<span></span>
						</label>
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('name')"
						@click="changeSorting('name')"
					>
						Name
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('email')"
						@click="changeSorting('email')"
					>
						Email
					</th>
					<th
						width="6%"
						class="th-sort text-left"
						:class="sortClass('username')"
						@click="changeSorting('username')"
					>
						Username
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('phone')"
						@click="changeSorting('phone')"
					>
						Phone
					</th>
					<th
						width="10%"
						class="th-sort text-left"
						:class="sortClass('role')"
						@click="changeSorting('role')"
					>
						Role
					</th>
					<th
						width="5%"
						class="th-sort text-left"
						:class="sortClass('is_active')"
						@click="changeSorting('is_active')"
					>
						Status
					</th>
					<th
						width="10%"
						class="th-sort text-left"
					>
						Actions
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in items" :key="item._id">
					<td class="align-middle">
						<label class="input-checkbox-container">
							<input
								type="checkbox"
								class="input-checkbox"
								:value="item._id"
								v-model="selectedItems"
							/>
							<span></span>
						</label>
					</td>
					<td>
						<div
							class="user__name d-flex text-bold flex-column"
						>
							<div
								class="user__image"
								:style="{ backgroundImage: `url(${item.picture})` }"
								v-if="item.picture"
							></div>
							<span class="text-primary cursor-pointer" @click="openUserProfile(item)">{{ item.name }}</span>
						</div>
					</td>
					<td>
						<div class="user__email d-flex align-items-center">
							<a :href="`mailto:${item.email}`" target="_blank">{{
								item.email
							}}</a>
						</div>
						<div class="d-flex align-items-center mt-1">
							<div
								class="user__id"
								v-tooltip="'User ID'">
								{{ item._id }}
							</div>
							<span class="cursor-pointer text-primary ml-1" v-tooltip="'Copy User ID'" @click="copyUserId(item)">
								<i class="bi bi-clipboard"></i>
							</span>
						</div>
					</td>
					<td>
						<div class="user__username">{{ item.username }}</div>
					</td>
					<td>
						<div class="user__phone">{{ item.phone }}</div>
						<div class="d-flex">
							<button
								type="button"
								class="submission-action active submission-action-chat mr-1"
								v-tooltip="$t('Follow-Up 1')"
								@click="followUp(item, 0)"
								>
								<i class="material-icons md-18">phone</i>
							</button>
							<button
								type="button"
								class="submission-action active submission-action-chat mr-1"
								v-tooltip="$t('Follow-Up 2')"
								@click="followUp(item, 1)">
								<i class="material-icons md-18">phone</i>
							</button>
						</div>
					</td>
					<td>
						<div class="user__role">{{ roleName(item.role) }}</div>
					</td>
					<td>
						<div class="user__status">
							<div class="status-pill success" v-if="item.is_active">
								Active
							</div>
							<div class="status-pill" v-if="!item.is_active">
								Inactive
							</div>
						</div>
					</td>
					<td>
						<div class="btn-group">
							<button class="btn btn-default btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
								{{ $t('Action') }}
							</button>
							<div class="dropdown-menu">
								<button
									type="button"
									class="dropdown-item"
									@click="editUserEmail(item)"
								>{{ $t('Change Email') }}</button>
								<button
									type="button"
									class="dropdown-item"
									v-if="isUserCan('admin_users_staff_view')"
									@click="editUserRole(item)"
								>{{ $t('Change Role') }}</button>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { copyToClipboard } from '@/lib/helper';

export default {
	name: 'UsersTableNonOwner',
	props: {
		items: {
			type: Array,
		},
	},
	data() {
		return {
			selectedItems: [],
			sort_by: 'created_at',
			sort: 'asc',
		};
	},
	watch: {
		selectedItems(val) {
			return this.$emit('selectedItems', val);
		},
	},
	methods: {
		roleName(role) {
			return role.replace('_', ' ');
		},
		followUp(user, type) {
			const item = {
				data_user: user,
				data_type: type,
			};
			return this.$emit('followUp', item);
		},
		editUserEmail(user) {
			return this.$emit('editUserEmail', user);
		},
		editUserRole(user) {
			return this.$emit('editUserRole', user);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		changeSorting(key) {
			const isSame 	= this.sort_by === key;
			this.sort_by 	= key;
			const sort 		= isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort 		= sort;
			const item = {
				sort_by: this.sort_by,
				sort: this.sort,
			};
			return this.$emit('sorting', item);
		},
		openUserProfile(user) {
			if (user.owner_type === 'supplier') {
				this.$emit('supplier-profile', user);
			} else {
				this.$emit('seller-profile', user);
			}
		},
		copyUserId(user) {
			copyToClipboard(user?._id);

			this.$notify({
				group: 'app',
				title: 'User ID Copied',
				text: user?._id,
				type: 'success',
			});
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isUserCan: 'isUserCan',
		}),
		selectAll: {
			get() {
				return this.items
					? this.selectedItems.length === this.items.length
					: false;
			},
			set(value) {
				const selected = [];
				if (value) {
					this.items.forEach((item) => {
						selected.push(item._id);
					});
				}
				this.selectedItems = selected;
			},
		},
	},
};
</script>
